import { render } from "./TemplateSeven.vue?vue&type=template&id=cf594f66"
import script from "./TemplateSeven.vue?vue&type=script&lang=js"
export * from "./TemplateSeven.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__